import { render, staticRenderFns } from "./addPlannedPaper.dialog.vue?vue&type=template&id=f6f396e6&scoped=true"
import script from "./addPlannedPaper.dialog.vue?vue&type=script&lang=js"
export * from "./addPlannedPaper.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f396e6",
  null
  
)

export default component.exports